<template>
    <div>
        <van-nav-bar v-if="!is_weixn()" fixed :title="$route.name" @click-left="onClickLeft"
                     style="background-color: #F7F7F7;">
            <template #left>
                <van-icon :class="[is_tabbar()?'hover-color':'']" name="arrow-left" role="button" aria-label="返回"/>
            </template>
        </van-nav-bar>

<!--        <keep-alive include="Buy">-->
            <router-view :style="'position: relative; margin-bottom:' + bottom + ';margin-top:' + top"/>
<!--        </keep-alive>-->
        <van-tabbar v-if="is_tabbar()" fixed v-model="selected" active-color="#1989fa" inactive-color="#BCBCBC" role="tablist" route>
            <van-tabbar-item name="首页" icon="home-o" to="/home" role="tab" aria-labelledby="bottomNav1">
                <span id="bottomNav1" aria-hidden="true">首页</span>
                <img slot="icon" slot-scope="slot" :alt="slot.active ? '已选中':'未选中'"
                     :src="slot.active ? require('@/assets/home-s.png') : require('@/assets/home.png')">
            </van-tabbar-item>
            <van-tabbar-item name="产品" icon="browsing-history-o" to="/productList" role="tab" aria-labelledby="bottomNav2">
              <span id="bottomNav2" aria-hidden="true">产品</span>
              <img slot="icon" slot-scope="slot" :alt="slot.active ? '已选中':'未选中'"
                   :src="slot.active ? require('@/assets/discover-s.png') : require('@/assets/discover.png')">
            </van-tabbar-item>
<!--            <van-tabbar-item name="金融教育" icon="browsing-history-o" to="/discover" role="tab" aria-labelledby="bottomNav3">
                <span id="bottomNav3" aria-hidden="true">金融教育</span>
                <img slot="icon" slot-scope="slot" :alt="slot.active ? '已选中':'未选中'"
                     :src="slot.active ? require('@/assets/discover-s.png') : require('@/assets/discover.png')">
            </van-tabbar-item>-->
            <van-tabbar-item name="我的" icon="manager-o" to="/me" role="tab" aria-labelledby="bottomNav4">
                <span id="bottomNav4" aria-hidden="true">我的</span>
                <img slot="icon" slot-scope="slot" :alt="slot.active ? '已选中':'未选中'"
                     :src="slot.active ? require('@/assets/me-s.png') : require('@/assets/me.png')">
            </van-tabbar-item>
        </van-tabbar>

        <van-image v-if="isCustomSharePage()" radius="25%" :src="require('@/assets/shareButton.png')" width="120px"
                   height="auto" class="share" @click="share"/>


        <div v-if="showShare" @click="showShare = false"
             style="background-color: rgba(0,0,0,0.7); position: fixed; top: 0; right: 0; bottom: 0; left: 0; z-index: 1000; display: flex; flex-direction: column; align-items: flex-end;">
            <van-image width="159px" height="280px" :src="require('@/assets/shareArrow.png')"
                       style="margin-top: 15px; margin-right: 33px;"/>
            <van-button plain round color="#ffffff"
                        style="align-self: center; margin-top: 8px; background-color: transparent; font-weight: bold; width: 255px;">
                点击右上角，分享给好友
            </van-button>
        </div>

    </div>
</template>

<script>

    import Vue from 'vue';
    import {NavBar, Tabbar, TabbarItem, Icon, Image, Button, Toast} from 'vant';
    import {isLogin} from '@/utils/commonUtils'
    import Store from '@/utils/store'

    Vue.use(NavBar).use(Tabbar).use(TabbarItem).use(Icon).use(Image).use(Button).use(Toast);

    export default {
        name: "Main",
        props: ['alt'],
        data() {
            return {
                selected: '',
                showShare: false
            }
        },
        watch: {
            $route: {
                handler(newVal) {
                    this.selected = newVal.name
                    document.title = newVal.name || '益宝'
                },
                deep: true
            }
        },
        computed: {
            top: function () {
                return this.is_weixn() ? '0' : '46px';
            },
            bottom: function () {
                return this.is_tabbar() ? '50px' : '0';
            },
        },
        methods: {
            isCustomSharePage() {
                return this.$route.meta.share
            },
            share() {
                Store.$emit('shareClick', this.$route.path)
                if (!isLogin()) {
                    this.$router.push({path: '/login', query: {redirectUrl: this.$route.path}})
                    return
                }
                if (this.is_weixn()) {
                    this.showShare = true;
                } else {
                    let url = process.env.VUE_APP_SHARE_URL + this.$route.fullPath + '&shareId=' + this.$store.state.user.user.userId
                    var textArea = document.createElement('textarea')
                    textArea.value = url
                    document.body.appendChild(textArea)
                    textArea.select()
                    try {
                        var msg = document.execCommand('copy') ? '成功' : '失败'
                        console.log('复制内容 ' + msg)
                    } catch (err) {
                        console.log('不能使用这种方法复制内容')
                    }
                    document.body.removeChild(textArea)
                    Toast.success('分享连接已成功复制');
                }
            },
            // is_weixn() {
            //     const ua = navigator.userAgent.toLowerCase();
            //     return (ua.indexOf('micromessenger') !== -1);
            // },
            is_weixn() {
                const ua = navigator.userAgent.toLowerCase();
                return (ua.indexOf('micromessenger') !== -1 || this.$route.path === '/Ahome' || this.$route.path === '/AInsurancePolicy');
            },
            is_tabbar() {
                return (this.$route.path === '/home' || this.$route.path === '/discover' || this.$route.path === '/me' || this.$route.path === '/productList');
            },
            onClickLeft() {
                this.$router.back();
            },

        }
    }

</script>

<style scoped>
    .hover-color{
        color: rgba(0,0,0,0);
    }
    .share {
        position: fixed;
        bottom: 80px;
        right: 10px;
    }
</style>
